module.exports = __webpack_public_path__ + "img/COM-B-2-I.d7e3475d.png";